import React from "react";
import AppDownloadButtons from "./AppDownloadButtons";

/**
 * DownloadCta — final call to action before the footer.
 */

const DownloadCta = () => {
  return (
    <section className="relative overflow-hidden bg-black pt-20 pb-24 border-t border-white/5">
      {/* ambient wash */}
      <div
        className="pointer-events-none absolute left-1/2 top-1/2 h-[120%] w-[120%] -translate-x-1/2 -translate-y-1/2 rounded-full"
        style={{
          background:
            "radial-gradient(45% 45% at 50% 42%, rgba(30,136,229,0.16), transparent 70%)",
        }}
        aria-hidden
      />

      <div className="container relative mx-auto max-w-5xl px-4 text-center">
        {/* Copy */}
        <p className="mx-auto max-w-md text-sm leading-relaxed text-gray-500">
          Get BetBond on iPhone, Android, or the web — P2P matching and
          community tips, with escrowed stakes and a clear fee.
        </p>

        <AppDownloadButtons className="mt-8" />

        <p className="mt-6 text-[11px] uppercase tracking-[0.22em] text-gray-600">
          18+ · Built in Rwanda · iOS app &amp; Android APK
        </p>
      </div>
    </section>
  );
};

export default DownloadCta;
